export const PHONE_CODE = Object.freeze([
    { value: '+60', iso: 'MY', text: '+60 (MY)' },
    // { value: '+62', iso: 'ID', text: '+62 (ID) Indonesia' },
    // { value: '+86', iso: 'CN', text: '+86 (CN) China' },
    // { value: '+65', iso: 'SG', text: '+65 (SG) Singapore' },
]);